import React from 'react'
import logo from "../../images/logo2.png"
import "./style.css"
const LoadingIntro = () => {
    return (
        <a className='loading-container' href='/'>

            <img src={logo} alt="Loading" className="loading-image" />

        </a>)
}

export default LoadingIntro